module.exports = __webpack_public_path__ + "img/114.02db4567.svg";